import {get, getOr, identity, indexOf} from 'lodash/fp';
import {
  getCurrentChapter,
  getEngine,
  getLives,
  getCurrentContent,
  getRoute,
  selectRoute,
  back,
  showTourguide,
  isTourguideEligible
} from '@coorpacademy/player-store';

const headerContent = (engineRef, state) => {
  const content = getCurrentContent(state);

  switch (engineRef) {
    case 'learner':
      return {
        title: getOr('', 'name')(content),
        details: get('levelTranslation')(content)
      };
    case 'microlearning':
    default:
      return {
        title: getOr('', 'name')(content)
      };
  }
};

const headerSubcontent = (engineRef, state) => {
  switch (engineRef) {
    case 'learner': {
      const chapter = getCurrentChapter(state);
      const level = getCurrentContent(state);
      const chapterIds = get('chapterIds', level);
      const details =
        chapter && chapterIds
          ? `${1 + indexOf(chapter._id, chapterIds)}/${chapterIds.length}`
          : null;

      return {
        title: getOr('', 'name', chapter),
        details
      };
    }
    case 'microlearning':
    default:
      return null;
  }
};

const buildHelpProps = (state, options, dispatch) => {
  const isQuestionTab = getRoute(state) === 'answer';
  const translate = getOr(identity, 'translate', options);
  const canShowHelp = isTourguideEligible(state, options);
  if (!canShowHelp) {
    return null;
  }
  return {
    onClick: () => {
      if (!isQuestionTab) {
        dispatch(selectRoute('answer'));
      }
      dispatch(showTourguide(undefined, true));
    },
    ariaLabel: translate('Help'),
    title: translate('Help')
  };
};

const headerProps =
  (options, {dispatch}) =>
  state => {
    const engine = getEngine(state);
    const {ref: engineRef} = engine;
    const {hide, count} = getLives(state);

    return {
      type: engineRef,
      content: {
        ...headerContent(engineRef, state),
        onClick: () => dispatch(back)
      },
      subcontent: headerSubcontent(engineRef, state),
      lives: hide ? false : {count},
      mode: getOr('default', 'mode', options),
      multiLang: get('multiLang', options),
      help: buildHelpProps(state, options, dispatch)
    };
  };

export default headerProps;
